import { UpdateIconButton, pn, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@compass/core";

import { ListBeProperty } from "components";
import { EndReasonListDto, EndReasonListResource, Permission, PermissionAction, SortObject } from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { endReasonPageRoute } from "../EndReasonPage/EndReasonPage";

export const EndReasonTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  endReasons: EndReasonListDto[];
  setEndReasons: (endReasons: EndReasonListDto[]) => void;
  resource: EndReasonListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<EndReasonListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<EndReasonListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<EndReasonListDto>("endReasonType"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.endReasons.map((endReasonItem) => (
            <TableRow
              key={endReasonItem.id}
              onClick={() =>
                navigate(
                  endReasonPageRoute.getPath({
                    id: endReasonItem.id,
                    crudMode: "view",
                  })
                )
              }
            >
              <TableCell type="id">{endReasonItem.id}</TableCell>
              <TableCell>{endReasonItem.name}</TableCell>
              <TableCell>{endReasonItem.endReasonType}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() =>
                      navigate(
                        endReasonPageRoute.getPath({
                          id: endReasonItem.id,
                          crudMode: "edit",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
